/* [
Copyright © 2020 Xah Lee

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the “Software”), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

URL: SVG Circle Arc http://xahlee.info/js/svg_circle_arc.html
Version 2019-06-19

] */

const cos = Math.cos;
const sin = Math.sin;
const pi = Math.PI;

const f_matrix_times = ([[a, b], [c, d]], [x, y]) => [
  a * x + b * y,
  c * x + d * y
];
const f_rotate_matrix = x => [
  [cos(x), -sin(x)],
  [sin(x), cos(x)]
];
const f_vec_add = ([a1, a2], [b1, b2]) => [a1 + b1, a2 + b2];

export const f_svg_ellipse_arc = ([cx, cy], [rx, ry], [t1, delta], rot) => {
  /* [
  returns a SVG path element that represent a ellipse.
  cx,cy → center of ellipse
  rx,ry → major minor radius
  t1 → start angle, in radian.
  delta → angle to sweep, in radian. positive.
  rot → rotation on the whole, in radian
  URL: SVG Circle Arc http://xahlee.info/js/svg_circle_arc.html
  Version 2019-06-19
   ] */
  delta = delta % (2 * pi);
  const rotMatrix = f_rotate_matrix(rot);
  const [sX, sY] = f_vec_add(
    f_matrix_times(rotMatrix, [rx * cos(t1), ry * sin(t1)]),
    [cx, cy]
  );
  const [eX, eY] = f_vec_add(
    f_matrix_times(rotMatrix, [rx * cos(t1 + delta), ry * sin(t1 + delta)]),
    [cx, cy]
  );
  const fA = delta > pi ? 1 : 0;
  const fS = delta > 0 ? 1 : 0;

  return (
    'M ' +
    sX +
    ' ' +
    sY +
    ' A ' +
    [rx, ry, (rot / (2 * pi)) * 360, fA, fS, eX, eY].join(' ')
  );
};
